// utils/data.js

/**
 * Check if dataset is valid (used for charts / metrics)
 * @param {Array} dataSets
 * @param {number} index (1-based index)
 * @returns {boolean}
 */
export function isValidData(dataSets, index) {
  const dataGet = dataSets?.[index - 1];
  let dataSet = null;

  if (Array.isArray(dataGet)) {
    dataSet = dataGet;
  } else if (dataGet?.dataSet) {
    dataSet = dataGet.dataSet;
  } else if (dataGet?.data) {
    dataSet = dataGet.data;
  }

  return (
    Array.isArray(dataSet) &&
    dataSet.length > 0 &&
    !dataSet.every(v => v === 0)
  );
}

/**
 * Checks if all items in the array have ratio and fundingRate equal to 0.
 * 
 * If all values are 0, returns an empty array.
 * Otherwise, returns the original array.
 *
 * @param {Array<Object>} arr - Array of objects containing ratio and fundingRate fields
 * @param {string|number} arr[].ratio - Ratio value (can be string or number)
 * @param {string|number} arr[].fundingRate - Funding rate value (can be string or number)
 *
 * @returns {Array<Object>} - Empty array if all values are 0, otherwise the original array
 */
export function filterZeroData(arr) {
  const isAllZero = arr.every(item => 
    Number(item.ratio) === 0 && Number(item.fundingRate) === 0
  );

  return isAllZero ? [] : arr;
}

/**
 * Return [] if array contains only 0s, otherwise return original value.
 */
export function normalizeZeroArray(arr) {
  if (!Array.isArray(arr)) return arr;

  return arr.every(value => value === 0) ? [] : arr;
}

export function isAllZeroArray(arr) {
  return Array.isArray(arr) && arr.every(value => value === 0);
}